"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfUserFeatureFlagsDto = instanceOfUserFeatureFlagsDto;
exports.UserFeatureFlagsDtoFromJSON = UserFeatureFlagsDtoFromJSON;
exports.UserFeatureFlagsDtoFromJSONTyped = UserFeatureFlagsDtoFromJSONTyped;
exports.UserFeatureFlagsDtoToJSON = UserFeatureFlagsDtoToJSON;
exports.UserFeatureFlagsDtoToJSONTyped = UserFeatureFlagsDtoToJSONTyped;
/**
 * Check if a given object implements the UserFeatureFlagsDto interface.
 */
function instanceOfUserFeatureFlagsDto(value) {
    if (!('featureFlags' in value) || value['featureFlags'] === undefined)
        return false;
    return true;
}
function UserFeatureFlagsDtoFromJSON(json) {
    return UserFeatureFlagsDtoFromJSONTyped(json, false);
}
function UserFeatureFlagsDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'featureFlags': json['featureFlags'],
    };
}
function UserFeatureFlagsDtoToJSON(json) {
    return UserFeatureFlagsDtoToJSONTyped(json, false);
}
function UserFeatureFlagsDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'featureFlags': value['featureFlags'],
    };
}
//# sourceMappingURL=UserFeatureFlagsDto.js.map